export default __webpack_public_path__ + "static/media/rentals-chart-empty.6ef46436.webp";